// NOTICE: This is gonna be the source of truth for layers in the app in general.
import { HazardCatalog, HazardProjection } from '@app/domains/hazards/types/hazard.types'
import { fetchLayers } from '@app/domains/layers/services/layers.service'
import { ContextualCatalog, ElementCatalog, Layers } from '@app/domains/layers/types/layers.types'
import { DialogData, LayerMetadata, LayerMetadataRecord } from '@app/types'
import { atom } from 'jotai'
import { atomWithRefresh } from 'jotai/utils'

// raw response, currently returns a <DialogData> response even when it's used in different components, not dialog related.
export const layersAtom = atomWithRefresh<Promise<DialogData>>(async () => {
  return await fetchLayers()
})

export const layersFormattedAtom = atom<Promise<Layers>>(async (get) => {
  const response = await get(layersAtom)

  return {
    elements: response.assetDialogData as unknown as ElementCatalog,
    hazards: {
      hazardDetails: response.hazardDialogData.hazardDetails as unknown as HazardCatalog,
      projections: response.hazardDialogData.projections as unknown as HazardProjection[],
    },
    contextuals: response.informationDialogData as unknown as ContextualCatalog,
    layerMetadata: response.layers ?? [],
  }
})

// patches applied after a successful upsert. Keyed by base layer ID.
// Resets on page reload persisted server data loads correctly via layersAtom.
// TODO: replace with atomWithQuery once metadata has a dedicated API endpoint.
export const pendingMetadataPatchesAtom = atom<Record<string, LayerMetadata>>({})

export const layerMetadataAtom = atom<Promise<LayerMetadataRecord[]>>(async (get) => {
  const layers = await get(layersFormattedAtom)
  const pendingPatches = get(pendingMetadataPatchesAtom)

  return layers.layerMetadata.map((layer) =>
    pendingPatches[layer.id] ? { ...layer, metadata: pendingPatches[layer.id] } : layer,
  )
})

layersAtom.debugLabel = 'layersAtom'
layersFormattedAtom.debugLabel = 'layersFormattedAtom'
pendingMetadataPatchesAtom.debugLabel = 'pendingMetadataPatchesAtom'
layerMetadataAtom.debugLabel = 'layerMetadataAtom'
